import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class DesignSystemForm extends ObjetKForm {
  name: string = ''
  description: string = ''
  organizationId: number = 0
  isDefault: boolean = false
  tokensJson: string = '{}'
  isActive: boolean = true

  static validationRules = {
    name: combineRules(requiredRule('Le nom est obligatoire')),
    organizationId: combineRules(requiredRule("L'organisation est obligatoire"))
  }

  constructor(data?: Partial<DesignSystemForm>) {
    super(data)
    if (data) {
      this.name = data.name ?? ''
      this.description = data.description ?? ''
      this.organizationId = data.organizationId ?? 0
      this.isDefault = data.isDefault ?? false
      this.tokensJson = data.tokensJson ?? '{}'
      this.isActive = data.isActive ?? true
    }
  }
}
